import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CastLayoutType } from '../../types';
import { FadeInOut } from '../../animations';

@Component({
  selector: 'hh-cast-layout',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './cast-layout.component.html',
  styleUrls: ['./cast-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeInOut]
})
export class CastLayoutComponent {
  @Input()
  public layout: CastLayoutType = 'layout-0';

  protected get isEmptyLayout(): boolean {
    return this.layout === 'layout-0';
  }
}
